<template>
	<v-container>
		<template>
			<div class="text-center">
				<v-dialog
				    v-model="dialog"
				    width="800"
                    @click:outside="closeModal"
                >
			        <v-card class="custom-card pb-120" rounded="0">
                        <v-toolbar
                            color="primary"
                            class="white--text"
                            flat
                        >

                            <v-toolbar-title class="font-weight-bold">{{ $t('userslist.editUser')}}</v-toolbar-title>

                            <v-spacer></v-spacer>

                            <v-btn icon class="white--text" @click="closeModal">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-form
                            ref="userEdit"
                            v-model="valid"
                            lazy-validation
                            autocomplete="off"
                        >
				        <v-card-text class="black--text">
                            <v-row>
						<v-col cols="6" class="py-0" >
                                    <label for="name">{{ $t('firstName')}}<span class="red--text">*</span></label>
                                    <v-text-field
                                        v-model="editedUser.firstName"
                                        :placeholder="$t('firstName')"
                                        outlined
                                        dense
                                        :error-messages="errors.firstName"
                                        :rules="rules.firstName"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <label for="name">{{ $t('lastName')}}<span class="red--text">*</span></label>
                                    <v-text-field
                                        v-model="editedUser.lastName"
                                        :placeholder="$t('lastName')"
                                        outlined
                                        dense
                                        :error-messages="errors.lastName"
                                        :rules="rules.lastName"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <label for="email">{{ $t('emailId')}}</label>
                                    <v-text-field
                                        v-model="editedUser.email"
                                        :placeholder="$t('emailId')"
                                        outlined
                                        dense
                                        :error-messages="errors.email"
                                        :rules="rules.email"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <label for="password">{{ $t('psw')}}</label>
                                    <v-text-field
                                        :type="showPassword ? 'text' : 'password'"
                                        v-model="password"
                                        placeholder="*****"
                                        outlined
                                        dense
                                        :error-messages="errors.password"
                                        :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                                        @click:append="showPassword = !showPassword"
                                    ></v-text-field>
                                </v-col>
                                <!-- <v-col cols="6" class="py-0">
                                    <label for="mobile">{{ $t('countryCode')}}<span class="red--text">*</span></label>
                                    <v-autocomplete
                                        outlined
                                        dense
                                        v-model="editedUser.countryCode"
                                        :items="countries"
                                        item-value="MobileCode"
                                        :filter="filterCountry"
                                        :rules="rules.country"
                                        :placeholder=" $t('countryCode')"
                                    >
                                        <template v-slot:item="slotProps" >
                                            <i :class="['mr-2', 'em', `em-flag-${slotProps.item.Code.toLowerCase()}`]"></i>
                                            {{`${slotProps.item.Name} (+${slotProps.item.MobileCode})` }}
                                        </template>
                                        <template slot="selection" slot-scope="data">
                                            <i :class="['mr-2', 'em', `em-flag-${data.item.Code.toLowerCase()}`]"></i>
                                            {{`${data.item.Name} (+${data.item.MobileCode})` }}
                                        </template>
                                    </v-autocomplete>
                                </v-col> -->
                                <!-- country starts -->
                                <v-col cols="6" class="py-0">
                                    <label for="country">{{
                                        $t("country")
                                    }}</label>
                                    <v-autocomplete outlined dense v-model="editedUser.countryId" :items="countries" item-value="name"
                                    item-text="name" :rules="rules.country" :placeholder="$t('country')"
                                    return-object @change="getState">
                                    <template v-slot:item="slotProps">
                                        <i :class="[
                                            'mr-2',
                                            'em',
                                            `em-flag-${slotProps.item.code.toLowerCase()}`,
                                        ]"></i>
                                        {{
                                            `${slotProps.item.name}`
                                        }}
                                    </template>
                                    <template slot="selection" slot-scope="data">
                                        <i :class="[
                                            'mr-2',
                                            'em',
                                            `em-flag-${data.item.code.toLowerCase()}`,
                                        ]"></i>
                                        {{ `${data.item.name}` }}
                                    </template>
                                    </v-autocomplete>
                                </v-col>
                                <!-- country ends -->

                                <!-- state starts -->
                                <v-col cols="6" class="py-0">
                                    <label for="state">{{
                                        $t(`${isKenyaClient() ? 'County' : 'provinceState'}`)
                                    }}<span class="red--text">*</span></label>
                                    <v-autocomplete outlined dense v-model="editedUser.stateId" :items="states" :filter="filterState"
                                    :error-messages="errors.state" :rules="rules.state" :placeholder="$t(`${isKenyaClient() ? 'County' : 'provinceState'}`)"
                                    return-object>
                                    </v-autocomplete>
                                </v-col>
                                <!-- state ends -->

                                <!-- city/town starts -->
                                <v-col cols="6" class="py-0">
                                    <label for="city">{{ $t("cityTown") }}<span class="red--text">*</span></label>
                                    <v-text-field type="text" v-model="editedUser.city" :placeholder="$t('cityTown')" outlined dense
                                    :error-messages="errors.city" :rules="rules.city"></v-text-field>
                                </v-col>
                                <!-- city/town ends -->
                                <!-- village starts (naccu/kenya only) -->
                                <v-col v-if="isKenyaClient()" cols="6" class="py-0">
                                    <label for="village">{{ $t("village") }}</label>
                                    <v-text-field type="text" v-model="editedUser.village" :placeholder="$t('village')" outlined dense></v-text-field>
                                </v-col>
                                <!-- village ends -->
                                <v-col cols="6" class="py-0">
                                    <label for="mobile">{{ $t('mobileNumber')}}</label>
                                    <v-text-field
                                        type="text"
                                        v-model="editedUser.mobile"
                                        :placeholder="$t('mobile')"
                                        outlined
                                        dense
                                        :error-messages="errors.mobile"
                                        :rules="rules.mobile"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <label for="department">{{ $t('department')}}<span class="red--text">*</span></label>
                                    <v-select
                                        v-model="editedUser.department_id"
                                        :items="departmentList"
                                        item-text="name"
                                        item-value="id"
                                        outlined
                                        dense
                                        :error-messages="errors.department"
                                        @change="getRoles"
                                        :rules="rules.department"
                                        :placeholder="$t('selectDept')"
                                    ></v-select>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <label for="role">{{ $t('role')}}<span class="red--text">*</span></label>
                                    <v-select
                                        v-model="roleIds"
                                        :items="rolesList"
                                        item-text="name"
                                        item-value="id"
                                        multiple
                                        chips
                                        outlined
                                        dense
                                        :error-messages="errors.role"
                                        :loading="roleLoading"
                                        :rules="rules.role"
                                        :placeholder="$t('selectRole')"
                                        @change="onRoleChange"
                                    ></v-select>
                                </v-col>
                                <v-col cols="6" class="py-0" v-if="isKenyaClient()">
                                    <label for="societies">{{ isKenyaClient() ? $t('factories') : $t('societies') }}</label>
                                    <v-autocomplete
                                        v-model="editedUser.societies"
                                        :items="societiesList"
                                        item-text="fullName"
                                        item-value="id"
                                        :placeholder="isKenyaClient() ? $t('selectFactories') : $t('selectSocieties')"
                                        outlined
                                        dense
                                        multiple
                                        chips
                                        deletable-chips
                                        :disabled="!isSocietyAdmin"
                                        :error-messages="errors.societies"
                                        :rules="rules.societies"
                                        :loading="societiesLoading"
                                    >
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <label for="mobile">{{ $t('status')}}<span class="red--text">*</span></label>
                                     <v-radio-group
                                        row
                                        class="mt-n1"
                                        v-model="editedUser.active"
                                    >
                                        <v-radio
                                            :label="$t('active')"
                                            :value="true"
                                        ></v-radio>
                                        <v-radio
                                            :label="$t('deactivated')"
                                            :value="false"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="py-0">
                                    <v-checkbox
                                        v-model="generateSecretKey"
                                        :label="generatedSecretKey ? ($t('secretKey') || 'Secret Key') : ($t('generateSecretKey') || 'Generate Secret Key')"
                                        color="primary"
                                        @change="onGenerateSecretKeyChange"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row v-if="generatedSecretKey">
                                <v-col cols="12" class="py-0">
                                    <v-text-field
                                        :value="generatedSecretKey"
                                        readonly
                                        outlined
                                        dense
                                        append-icon="mdi-content-copy"
                                        @click:append="copySecretKey"
                                        :hint="$t('copySecretKeyHint')"
                                        persistent-hint
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-card-actions class="mt-10">
                                <v-spacer></v-spacer>
                                <v-btn @click="closeModal" outlined right height="44" width="116" depressed color="primary">
                                    {{ $t('cancel')}}
                                </v-btn>
                                <v-btn @click="updateUser" right height="44" width="116" color="primary">
                                    {{ $t('submit')}}
                                </v-btn>
                            </v-card-actions>
				        </v-card-text>
                        </v-form>
			        </v-card>
		        </v-dialog>
	        </div>
        </template>
    </v-container>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin"
import generalMixin from "@/mixins/GeneralMixin";
import PermissionsMixin from "@/mixins/PermissionsMixin"
import { isKenyaClient, isSocietyAdminRole } from "@/utils";
import UserService from "@/_services/UserService"
// import {countries} from "@/constants/countries.js"
import { kenyaCounties } from "@/constants/countries.js"
import { getCountries, getStates } from 'country-state-picker'
import _ from 'lodash'

	export default {
        mounted() {
            // console.log('uuu',this.editedUser)
            this.getCountry();
            this.setEditeduser()
            const fetchData = async () => {
                this.startLoading()
                this.departmentList = await this.getDepartments()
                // if(this.editedUser.department)
                this.getRoles(this.editedUser.department)
                await this.getSocieties()
                this.$refs.userEdit.validate()
                this.stopLoading()
            }
            fetchData()
        },
        computed: {
            dialog()  {
                return this.dialogU;
            },
            isSocietyAdmin() {
                const roleId = (this.editedUser && this.editedUser.role_id) ? String(this.editedUser.role_id).toLowerCase() : ''
                const isAdmin = isSocietyAdminRole(roleId)
                console.log('isSocietyAdmin computed:', { roleId, isAdmin, editedUser: this.editedUser })
                return isAdmin
            }
        },
        watch: {
            'editedUser.role_id'(newRoleId, oldRoleId) {
                // When role changes away from society admin, clear societies
                if (oldRoleId) {
                    const oldRole = String(oldRoleId).toLowerCase();
                    const newRole = newRoleId ? String(newRoleId).toLowerCase() : '';
                    const wasSocietyAdmin = isSocietyAdminRole(oldRole);
                    const isSocietyAdmin = isSocietyAdminRole(newRole);
                    
                    
                    if (wasSocietyAdmin && !isSocietyAdmin) {
                        // Role changed from society admin to something else, clear societies
                        this.editedUser.societies = [];
                    }
                }
            },
        },
        data() {
            return {
                countries: [],
                states: [],
                valid: true,
                departmentList: [],
                rolesList: [],
                roleIds:[],
                roleLoading: false,
                fieldType: { text: 'text'},
                error: false,
                errors: { firstName: '', lastName: '', email: '', mobile: '', password: '', department: '', role: '', country: "", state: "",city: "", societies: ''},
                editedUser: {},
                password: '',
                showPassword: false,
                societiesList: [],
                societiesLoading: false,
                generateSecretKey: false,
                generatedSecretKey: '',
                rules: {
                    firstName: [
                        v => (!!v || v != '' || v != null) || this.$t('addEdituser.firstNameRequired'),
                        v => /^[a-z0-9\s]+$/i.test(v) || this.$t('addEdituser.firstNameOllyAlpha'),
                        v => (v && v.length <= 50) || this.$t('addEdituser.firstNameLimit'),
                    ],
                    lastName: [
                        v => !!v || this.$t('addEdituser.lastNameRequired'),
                        (v) => /^[a-z0-9\s]+$/i.test(v) || this.$t('addEdituser.lastNameOllyAlpha'),
                        v => (v && v.length <= 50) || this.$t('addEdituser.lastNameLimit'),
                    ],
                    // Email and mobile are individually optional - updateUser() enforces
                    // that at least one of the two is provided.
                    email: [
                        v => !v || /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/.test(v) || this.$t('addEdituser.emailInvalid'),
                    ],
                    mobile: [
                        v => !v || this.validMobileNumber(v) || this.$t('addEdituser.invalidMobile'),
                    ],
                    department: [
                        v => !!v || this.$t('addEdituser.deptRequired'),
                    ],
                    role: [
                        v => !!v || this.$t('addEdituser.roleRequired'),
                    ],
                    country: [(v) => !!v || this.$t("addEdituser.countryRequired")],
                    state: [(v) => !!v || this.$t(`${isKenyaClient() ? 'County is required' : 'stateRequired'}`)],
                    city: [(v) => !!v || this.$t("cityIsReq")],
                    societies: [
                        // optional validation
                    ],
                }
            }
        },
        methods: {
            isKenyaClient() {
                return isKenyaClient();
            },
            closeModal() {
                this.generateSecretKey = false;
                this.generatedSecretKey = '';
                this.showPassword = false;
                this.$emit('closeUpdateUser')
            },
			hasSubOrg() {
				try {
					const u = JSON.parse(localStorage.getItem('user'))
					return !!(u && (u.subOrgId || u.subOrganizationId))
				} catch (e) {
					return false
				}
			},
            async setEditeduser(){
                    this.editedUser = _.clone(this.user, true);
                    this.editedUser.userId = this.user.id
                    // this.editedUser.firstName = this.user.firstName
                    // this.editedUser.lastName = this.user.lastName
                    // this.editedUser.mobile = this.user.mobile
                    // this.editedUser.email = this.user.email, 
                    const roleId = this.user.user_role_assoc.length > 0 ? this.user.user_role_assoc[0].id : ''
                    // Use $set to ensure reactivity
                    this.$set(this.editedUser, 'role_id', roleId)
                    this.$set(this.editedUser, 'department_id', this.user.user_dept_assoc.length > 0 ? this.user.user_dept_assoc[0].id : '')
                    this.editedUser.countryCode = this.user.countryCode                     
                    // Fetch societies associated with this user
                    await this.fetchUserSocieties();
                    this.roleIds = this.user.user_role_assoc.map(role => role.id);

                    // Populate secretKey if user already has one
                    if (this.user.secretKey) {
                        this.generatedSecretKey = this.user.secretKey;
                        this.generateSecretKey = true;
                    }

                    const _country = this.countries.find(item => item.name === this.editedUser.countryId)
                    if (_country) {
                        this.getState(_country)
                    }
            },
            async fetchUserSocieties() {
                try {
                    // If user already has societies in the prop, use them
                    if (Array.isArray(this.user.societies) && this.user.societies.length > 0) {
                        this.editedUser.societies = this.user.societies
                            .map(s => (typeof s === 'object' && s !== null) ? (s.id || s.societyId) : s)
                            .filter(Boolean);
                        return;
                    }

                    // Otherwise, fetch from backend
                    const response = await this.$http.get(`/user/${this.user.id}/societies`);
                    if (response.data && response.data.success) {
                        const societyIds = response.data.data.map(s => s.societyId || s.id);
                        this.editedUser.societies = societyIds;
                    } else {
                        this.editedUser.societies = [];
                    }
                } catch (e) {
                    console.error('Error fetching user societies:', e);
                    this.editedUser.societies = Array.isArray(this.user.societies)
                        ? this.user.societies
                              .map(s => (typeof s === 'object' && s !== null) ? (s.id || s.societyId) : s)
                              .filter(Boolean)
                        : [];
                }
            },
            updateUser() {
                this.emptyErrors();
                // mobile can come back from the API as a number, so normalise before trimming
                const hasEmail = String(this.editedUser.email ?? '').trim() != '';
                const hasMobile = String(this.editedUser.mobile ?? '').trim() != '';
                if (!hasEmail && !hasMobile) {
                    this.errors.email = 'Email or mobile number is required.';
                    this.errors.mobile = 'Email or mobile number is required.';
                    return;
                }

                if(this.password && this.password.trim() != ''){
                     this.editedUser.password = this.password;
                }
                
                this.editedUser.country = typeof this.editedUser.countryId == "object"? this.editedUser.countryId.name : this.editedUser.countryId;
                this.editedUser.state = this.editedUser.stateId;
                this.editedUser.countryCode = typeof this.editedUser.countryId == "object"? this.editedUser.countryId.dial_code : this.editedUser.dial_code;
                this.editedUser.roleIds = this.roleIds;

                if(!this.$refs.userEdit.validate()) return;
                this.startLoading()
                
                // Only clear societies if user is NOT a society admin
                // Society admins should always be able to have societies, regardless of subOrg
                if (!this.isSocietyAdmin) {
                    this.editedUser.societies = []
                } else if (!this.hasSubOrg()) {
                    // If society admin but no subOrg, still allow societies (might be needed)
                    // Keep societies as is
                }
                
                // Ensure societies is always an array when sending
                if (!Array.isArray(this.editedUser.societies)) {
                    this.editedUser.societies = []
                }
                
                // Include secretKey if checkbox is checked
                if (this.generateSecretKey && this.generatedSecretKey) {
                    // Use the existing or generated secret key
                    this.editedUser.secretKey = this.generatedSecretKey;
                } else if (!this.generateSecretKey) {
                    // If checkbox is unchecked, don't send secretKey (will keep existing one in DB)
                    // To clear it, we'd need to explicitly set it to null, but for now we'll preserve existing
                    // Remove secretKey from update if checkbox is unchecked
                    delete this.editedUser.secretKey;
                }
                
                UserService.updateUser(this.editedUser.userId, this.editedUser)
                .then( data => {
                    if(data.success){
                        this.$emit('userUpdated', { success:true, message: data.message});
                    }else{
                        this.$emit('userUpdated', { success:false, message: data.message});
                    }
                    this.closeModal();
                    this.stopLoading()
                })
                .catch( err => {
                    try {
                        var errors = err.response?.data?.message?.errors?.[0];
                        if (errors) {
                            this.$notify({
                                title: this.$t('unableToUpdate'),
                                text: `${errors.msg} - ${errors.value} for ${errors.param}`,
                                type: 'error'
                            });
                        } else {
                            const errorMessage = err.response?.data?.message || err.message || this.$t('unableToUpdate');
                            this.$notify({
                                title: this.$t('unableToUpdate'),
                                text: errorMessage,
                                type: 'error'
                            });
                        }
                    } catch (notifyError) {
                        console.error('Error handling update error:', notifyError);
                        this.$notify({
                            title: this.$t('unableToUpdate'),
                            text: err.message || 'An error occurred while updating the user',
                            type: 'error'
                        });
                    } finally {
                        this.stopLoading();
                    }
                });
            },

            emptyErrors() {
                this.error = false;
                this.errors.name = '';
                this.errors.email = '';
                this.errors.mobile = '';
                this.errors.password = '';
                this.errors.department = '';
                this.errors.role = '';
            },
            async getRoles() {
                this.rolesList = []
                this.roleLoading = true
                this.rolesList = await this.getRolesList()
                this.roleLoading = false
            },
            onRoleChange(roleId) {
                // Force Vue to update by ensuring editedUser.role_id is set reactively
                this.$set(this.editedUser, 'role_id', roleId)
                // Force Vue to re-evaluate computed properties
                this.$forceUpdate()
                // If role is society admin and societies is not an array, initialize it
                const roleIdLower = roleId ? String(roleId).toLowerCase() : ''
                if (isSocietyAdminRole(roleIdLower)) {
                    if (!Array.isArray(this.editedUser.societies)) {
                        this.$set(this.editedUser, 'societies', [])
                    }
                }
            },
            countryMatch(x){
                // console.log('xx', x.MobileCode, this.editedUser.countryCode)
                if(!this.editedUser.countryCode) return false;
                if(x.MobileCode == this.editedUser.countryCode) return true;

                return false;
            },
            getCountry() {
                this.countries = getCountries()
            },
               getState(val) {
                console.log('val', val);
                if(val.code == "ke") {
                    this.states = kenyaCounties;
                    console.log(this.states, 'states');
                   return;
                }
                this.states = getStates(val.code)
                console.log(this.states, 'states');
                this.country = val
            },
            async getSocieties() {
                if (this.societiesLoading) return;
                this.societiesLoading = true;
                try {
                    // Load all factory buying stations at once; search handled client-side by v-autocomplete
                    // Include userId when editing so already-associated buying stations are shown
                    const userIdParam = this.editedUser && this.editedUser.userId ? `&userId=${this.editedUser.userId}` : '';
                    const response = await this.$http.get(`/available-buying-stations?limit=100000${userIdParam}`);
                    if (response.data && response.data.success) {
                        this.societiesList = response.data.data.rows || [];
                    }
                } catch (e) {
                    this.societiesList = [];
                } finally {
                    this.societiesLoading = false;
                }
            },
            generateSecretKeyValue() {
                // Generate a 256-bit (32-byte) secret key encoded as hex (64 characters)
                const bytes = new Uint8Array(32); // 32 bytes = 256 bits
                
                // Use crypto.getRandomValues for cryptographically secure random bytes
                if (window.crypto && window.crypto.getRandomValues) {
                    window.crypto.getRandomValues(bytes);
                } else {
                    // Fallback to Math.random (less secure, but better than nothing)
                    for (let i = 0; i < 32; i++) {
                        bytes[i] = Math.floor(Math.random() * 256);
                    }
                }
                
                // Convert bytes to hex string (64 hex characters)
                let secretKey = '';
                for (let i = 0; i < bytes.length; i++) {
                    const hex = bytes[i].toString(16).padStart(2, '0');
                    secretKey += hex;
                }
                
                return secretKey;
            },
            onGenerateSecretKeyChange() {
                if (this.generateSecretKey) {
                    // Only generate a new key if one doesn't already exist
                    if (!this.generatedSecretKey) {
                        this.generatedSecretKey = this.generateSecretKeyValue();
                    }
                    // If secretKey already exists, keep it (don't regenerate)
                } else {
                    // Clear the secret key when checkbox is unchecked
                    this.generatedSecretKey = '';
                }
            },
            copySecretKey() {
                if (this.generatedSecretKey) {
                    navigator.clipboard.writeText(this.generatedSecretKey).then(() => {
                        this.$notify({
                            title: this.$t('copied') || 'Copied',
                            text: this.$t('secretKeyCopied') || 'Secret key copied to clipboard',
                            type: 'success'
                        });
                    }).catch(() => {
                        // Fallback for older browsers
                        const textArea = document.createElement('textarea');
                        textArea.value = this.generatedSecretKey;
                        document.body.appendChild(textArea);
                        textArea.select();
                        document.execCommand('copy');
                        document.body.removeChild(textArea);
                        this.$notify({
                            title: this.$t('copied') || 'Copied',
                            text: this.$t('secretKeyCopied') || 'Secret key copied to clipboard',
                            type: 'success'
                        });
                    });
                }
            },
        },
        props: {
            'dialogU': {
                type: Boolean,
                required: true
            }, 
            'user': {
                type: Object,
                required: true
            }},
        mixins: [loadingMixin, generalMixin, PermissionsMixin]
    };
</script>

<style lang="scss">
.v-dialog::-webkit-scrollbar {
  width: 0px;
}
.v-dialog::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
.v-dialog::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.custom-card {
	background: #FFFFFF !important;
	box-shadow: 0px 30px 30px rgb(106 119 132 / 41%) !important;
	border-radius: 23px !important;
}
.custom-card .v-card__text {
	width: 100%;
	padding: 37px 60px !important;
}
.card-heading-1 {
	margin-bottom: 28px;
}
.custom-card .v-card__text .card-heading-1 h2 {
	font-size: 30px;
	font-weight: 700;
}
// .custom-card .form {
// 	margin-bottom: 22px;
// }
.form label {
	display: inline-block;
	max-width: 100%;
	// margin-bottom: 5px;
	font-size: 15px;
	font-family: Poppins-Medium;
}
.form .form-control {
	display: block;
	width: 100%;
	height: 36px;
	padding: 6px 12px;
	font-size: 14px;
	line-height: 1.42857143;
	/* color: #555; */
	background-color: #fff;
	border: 1px solid #C7D5E1;
	border-radius: 3px;
}
.form .form-control::placeholder{
	font-size:13px;
	font-family: pop_regular;
	color:#97A8B8;
}
.form .form-control:focus-visible {
	outline: none;
}
// .form-control-2 {
// 	display: block;
// 	width: 100%;
// 	height: 36px;
// 	padding: 1px 20px;
// 	line-height: 1.5;
// 	transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
// 	background: #fff;
// 	border: 1px solid #C7D5E1;
// 	border-radius: 3px;
// 	background-position: calc(100% - 1.20rem) center !important;
// 	-moz-appearance: none !important;
// 	-webkit-appearance: none !important;
// 	appearance: none !important;
// 	background-image: url(/img/drop2.png);
// 	background-repeat: no-repeat;
// 	font-size: 14px;
// 	/* color:#C7D5E1; */
// 	font-family: pop_regular;
// }
.btn-custom-11 .btn-11{
    width: 135px;
    background: #fff !important;
    color:$outline-color !important;
    border: 1px solid #97A8B8 !important;
}
.btn-custom-11 .btn-22 {
    width: 135px;
    background: $primary-color !important;
    color:#fff !important;
    margin-left: 10px;
}
.btn-custom-11{
	margin-top: 38px;
}
</style>
